module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-age-gate-expanded-row">\n  <div class="fmcy-age-gate-content-wrapper">\n    <div class="fmcy-age-gate-icon-wrapper">\n      <div class="fmcy-age-gate-icon"></div>\n    </div>\n    <div class="fmcy-age-gate-title-wrapper">\n      <h1 class="fmcy-age-gate-title">Are you at least 19 years old?</h1>\n    </div>\n  </div>\n  <div class="fmcy-age-gate-button-bar container-fluid">\n    <div class="fmcy-age-gate-button-bar-inner row">\n      <div class="col-xs-6">\n        <div class="fmcy-no-button-region"></div>\n      </div>\n      <div class="col-xs-6">\n        <div class="fmcy-yes-button-region"></div>\n      </div>\n    </div>\n  </div>\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/entry-flow/age-gate/age-gate.html
 ** module id = 858
 ** module chunks = 1 39 104
 **/